export function resolveMessageText(spokenText, input) {
    if (typeof spokenText === 'string' && spokenText.trim()) {
        return spokenText.trim();
    }

    return typeof input === 'string' ? input.trim() : '';
}
